import { NgModule, Optional, SkipSelf, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { AuthGuard } from '@core/guard/auth.guard';
import { NoAuthGuard } from '@core/guard/no-auth.guard';
import { throwIfAlreadyLoaded } from '@core/guard/module-import.guard';
import { TokenInterceptor } from '@core/interceptor/token.interceptor';
import { SpinnerInterceptorService } from '@core/interceptor/spinner.interceptor';
import { AuthService } from './services/auth.service';
import { ProfileService } from '@data/services/profile.service';
import { AlertService } from '@core/services/alert.service';
import { DatePipe } from '@angular/common';
import {EncryptService} from './services/encrypt.service';
import {SpinnerService } from './services/spinner.service';
import { ThemeService } from '@core/services/theme.service';
import { environment } from '@env/environment';
import { SelectAccountService } from '@core/services/select-account.service';
import { UtilitiesService } from '@core/services/utilities.service';



export function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: environment.keycloakConfig,
      bearerExcludedUrls: ['/assets'],
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri:
          window.location.origin + '/assets/silent-check-sso.html',
      },
    });
}

@NgModule({
  imports: [
    HttpClientModule,
    KeycloakAngularModule
  ],
  providers: [
    AuthGuard,
    NoAuthGuard,
    AuthService,
    ProfileService,
    AlertService,
    DatePipe,
    EncryptService,
    SpinnerService,
    UtilitiesService,
    SelectAccountService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptorService,
      multi: true},
    {
      provide: APP_INITIALIZER,
      useFactory: (themeService: ThemeService) => () => themeService.loadTheme(),
      deps: [ThemeService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
    {provide: 'googleTagManagerId',  useValue: environment.googleTagManagerId}
  ]
})




export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
